import { ColorSchemasEnum } from '../../../constants/constants';

const getBackgroundInput = (settingsStyle: ColorSchemasEnum) => {
  return 'rgba(255, 255, 255, 0.15)';
};

export { getBackgroundInput };
